import React from "react";
import "./legal.css";
import Footer from "./Footer";

const Cookies = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Cookies Policy</h1>

        <p>
          KostPadi uses cookies and similar technologies to improve user
          experience and platform performance.
        </p>

        <h2>Types of Cookies</h2>

        <ul>
          <li>Authentication cookies</li>
          <li>Analytics cookies</li>
          <li>Preference cookies</li>
          <li>Security cookies</li>
        </ul>

        <h2>Managing Cookies</h2>

        <p>
          Users may disable cookies through browser settings, although some
          platform functionality may be affected.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default Cookies;
